export const financialYears = [2024, 2025];

export const financialDataByYear = {
  2024: {
    year: 2024,
    label: 'FY 2024',
    summary: {
      totalRevenue: 550,
      totalExpenses: 465,
      netProfit: 85,
      ebitda: 120,
      revenueGrowth: 5.8,
      profitMargin: 15.5,
      ebitdaMargin: 21.8,
      expenseRatio: 84.5,
    },
    highlights: [
      { value: '+5.8%', label: 'Revenue Growth', description: 'Year-over-year growth vs FY 2023' },
      { value: '$550M', label: 'Total Revenue', description: 'Annual revenue FY 2024' },
      { value: '21.8%', label: 'EBITDA Margin', description: 'Operating profitability' },
      { value: '$85M', label: 'Net Profit', description: '15.5% profit margin' },
    ],
    revenueByIndustry: {
      labels: ['Technology', 'FMCG', 'Hospitality', 'Construction', 'Fashion', 'Logistics', 'Consulting', 'Finance'],
      values: [120, 80, 65, 70, 40, 55, 25, 95],
    },
    revenueBreakdown: [
      { sector: 'Technology', revenue: 120, growth: '+40%', margin: '65%' },
      { sector: 'FMCG', revenue: 80, growth: '+12%', margin: '30%' },
      { sector: 'Hospitality', revenue: 65, growth: '+15%', margin: '45%' },
      { sector: 'Construction', revenue: 70, growth: '+18%', margin: '35%' },
      { sector: 'Fashion & Lifestyle', revenue: 40, growth: '+22%', margin: '40%' },
      { sector: 'Logistics', revenue: 55, growth: '+25%', margin: '28%' },
      { sector: 'Consulting', revenue: 25, growth: '+30%', margin: '55%' },
      { sector: 'Finance & Banking', revenue: 95, growth: '+35%', margin: '50%' },
    ],
    plTrend: {
      labels: ['2020', '2021', '2022', '2023', '2024'],
      revenue: [350, 420, 480, 520, 550],
      expenses: [280, 330, 375, 410, 465],
      netProfit: [70, 90, 105, 110, 85],
    },
    expenseBreakdown: {
      'R&D': 85,
      'Marketing': 65,
      'Operations': 140,
      'Staff': 110,
      'CSR Contributions': 20,
      'Expansion Capex': 45,
    },
    cashFlow: {
      operating: 95,
      investing: -40,
      financing: 15,
      net: 70,
    },
    investments: [
      {
        title: 'Series A — Blockchain',
        amount: '$25M',
        description: 'Funding for Dot Protocol expansion, TauOS development, and global blockchain infrastructure deployment.',
        points: ['Layer 1 blockchain expansion', 'AI-native OS development', 'Global infrastructure'],
      },
      {
        title: 'Growth — Hospitality',
        amount: '$15M',
        description: 'Expansion of sustainable hospitality portfolio across Southeast Asia and Middle East markets.',
        points: ['Eco-resort development', 'Regional expansion', 'Sustainable tourism'],
      },
      {
        title: 'Strategic — Logistics',
        amount: '$10M',
        description: 'Technology-driven logistics expansion with focus on e-commerce fulfillment and last-mile delivery.',
        points: ['Tech infrastructure', 'E-commerce enablement', 'Last-mile solutions'],
      },
    ],
  },

  2025: {
    year: 2025,
    label: 'FY 2025',
    summary: {
      totalRevenue: 930,
      totalExpenses: 539,
      netProfit: 391,
      ebitda: 390,
      revenueGrowth: 69.1,
      profitMargin: 42.0,
      ebitdaMargin: 41.9,
      expenseRatio: 58.0,
    },
    highlights: [
      { value: '+69%', label: 'Revenue Growth', description: 'Year-over-year growth vs FY 2024' },
      { value: '$930M', label: 'Total Revenue', description: 'Annual revenue FY 2025' },
      { value: '41.9%', label: 'EBITDA Margin', description: 'Strong operating performance' },
      { value: '$391M', label: 'Net Profit', description: '42.0% profit margin' },
    ],
    revenueByIndustry: {
      labels: ['Technology', 'FMCG', 'Hospitality', 'Construction', 'Fashion', 'Logistics', 'Consulting', 'Finance', 'Telecom', 'Defence'],
      values: [181, 121, 98, 106, 60, 83, 38, 143, 45, 55],
    },
    revenueBreakdown: [
      { sector: 'Technology', revenue: 181, growth: '+51%', margin: '68%' },
      { sector: 'FMCG', revenue: 121, growth: '+51%', margin: '34%' },
      { sector: 'Hospitality', revenue: 98, growth: '+51%', margin: '48%' },
      { sector: 'Construction', revenue: 106, growth: '+51%', margin: '38%' },
      { sector: 'Fashion & Lifestyle', revenue: 60, growth: '+50%', margin: '43%' },
      { sector: 'Logistics', revenue: 83, growth: '+51%', margin: '31%' },
      { sector: 'Consulting', revenue: 38, growth: '+52%', margin: '58%' },
      { sector: 'Finance & Banking', revenue: 143, growth: '+51%', margin: '53%' },
      { sector: 'Telecom', revenue: 45, growth: 'New', margin: '62%' },
      { sector: 'Defence Technology', revenue: 55, growth: 'New', margin: '71%' },
    ],
    plTrend: {
      labels: ['2021', '2022', '2023', '2024', '2025'],
      revenue: [420, 480, 520, 550, 930],
      expenses: [330, 375, 410, 465, 539],
      netProfit: [90, 105, 110, 85, 391],
    },
    expenseBreakdown: {
      'R&D': 98,
      'Marketing': 75,
      'Operations': 162,
      'Staff': 127,
      'CSR Contributions': 23,
      'Expansion Capex': 54,
    },
    cashFlow: {
      operating: 410,
      investing: -95,
      financing: 42,
      net: 357,
    },
    investments: [
      {
        title: 'Strategic — Digital Infrastructure',
        amount: '$45M',
        description: 'Accelerating Dot Protocol, Numbr telecom expansion, and enterprise blockchain deployment across portfolio companies.',
        points: ['Layer 1 scale-up', 'Telecom integration', 'Cross-portfolio rails'],
      },
      {
        title: 'Growth — Defence & AI',
        amount: '$30M',
        description: 'Investment in The Brain, The Biis, and AI-driven defence technology platforms.',
        points: ['Defence systems R&D', 'AI integration', 'Global partnerships'],
      },
      {
        title: 'Expansion — Real Assets',
        amount: '$22M',
        description: 'Construction, hospitality, and logistics expansion across Asia-Pacific and Middle East markets.',
        points: ['Eco-resort pipeline', 'Smart logistics hubs', 'Sustainable construction'],
      },
    ],
  },
};

export const getFinancialData = (year) => financialDataByYear[year] ?? financialDataByYear[2025];
